module.exports = __webpack_public_path__ + "static/img/A59.b2e4b241.jpg";